import React from 'react';
import { Campaign } from 'circulator/components/Campaign';

export const CampaignAnalyticsPage = () => <Campaign debug />;
